import React, { useEffect } from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import TextInput from "../../input/TextInput";
import PhoneInput from "../../input/PhoneInput";
import { useAuth } from "oidc-react";
import EmailInput from "../../input/EmailInput";
import ShowHideDiv from "../../structure/ShowHideDiv";
import { useEmployer } from "../../../hooks/useEmployer";
import { useFormikContext } from "formik";
import { EmployerFormValues } from "../../common/EmployerFormValues";
import NameInput from "../../input/NameInput";
import { useGuestAuth } from "../../guest/GuestAuthProvider";

const AboutEmployer = () => {
    const { values, setFieldValue } = useFormikContext<EmployerFormValues>();
    const auth = useAuth();
    const { guestAuth } = useGuestAuth();
    const userData = auth.userData;
    const signedIn = !!userData;
    const activeGuestEmail = signedIn ? undefined : guestAuth?.email?.trim();

    const { data: employerData } = useEmployer(auth)
    const employer = employerData?.findEmployer

    useEffect(() => {
        if (!employer) {
            return;
        }
        if (!activeGuestEmail) {
            setFieldValue('employerEmailAddress', employer.emailAddress)
        }
        setFieldValue('employerContactName', employer.contactName)
    }, [activeGuestEmail, employer, setFieldValue])

    useEffect(() => {
        if (activeGuestEmail && values.employerEmailAddress !== activeGuestEmail) {
            setFieldValue('employerEmailAddress', activeGuestEmail)
        }
    }, [activeGuestEmail, setFieldValue, values.employerEmailAddress])

    return (
        <QuestionPanel headerText="Let's gather some information about you."
            panelContent={
                <div>
                    <NameInput id="employer-contact-name" label="Employer contact name" required={true} maxLength={75} />
                    <ShowHideDiv show={!signedIn}>
                        <TextInput id="employer-name" label="Policyholder name" required={true} maxLength={75} />
                        <TextInput id="employer-title" label="Employer contact title" required={false} />
                        <PhoneInput id="employer-phone-number" label="Employer contact phone" required={true} />
                    </ShowHideDiv>
                    <EmailInput id="employer-email-address" label="Employer contact email" required={true} disabled={Boolean(activeGuestEmail)} />
                </div>
            } />
    )
};
export default AboutEmployer;